module.exports = __webpack_public_path__ + "img/Captain_Pependle.6a3559f2.png";